import { useEffect, useState } from 'react';

import { getGroupsData } from '@api/roleManagement';

export const useGroups = () => {
  const [groups, setGroups] = useState<any>([]);

  useEffect(() => {
    getGroupsData()
      .then((data) => setGroups(data.data))
      .catch((err) => console.log(err));
  }, []);

  return {
    groups,
  };
};
